/**
 * Мини-uuid. Используется для заглушек
 * Формат: TTTTTTTTTTTT RRRRRRRR CCCC   (hex)
 *          |           |        |
 *          |           |        └─ счётчик (16 бит)
 *          |           └────────── случайное число (32 бит)
 *          └────────────────────── метка времени (48 бит)
 */
const toHex = (n: number, len: number) => n.toString(16).padStart(len, '0');

let counter = 0; // 0-65535, затем обнуляется

export function tinyUuid(): string {
  // 48 бит текущего времени (хватит до 8925 года)
  const timePart = Date.now() & 0xffffffffffff;

  // 32 бита псевдослучайных данных
  const randomPart = (Math.random() * 0xffffffff) >>> 0;

  // 16 бит счётчика
  counter = (counter + 1) & 0xffff;

  // Склеиваем и возвращаем 24-символьную строку
  return (
    toHex(timePart, 12) + // 12 hex
    toHex(randomPart, 8) + // 8 hex
    toHex(counter, 4)      // 4 hex
  );
}